import * as moment from 'moment';

import { ExecutionsReportTypeEnum, ReportExecutionColumnNames } from '@spa/api';

import {LatinDigitsValidator, OnlyDigitsValidator} from '@spa/validators';

import {ComponentTypesEnum, UnspecifiedKeysEnum} from '../../../app/shared/enums';
import {FilterControlInterface} from '../../../app/shared/interfaces';
import {ReportTableColumn, ReportTableConfigInterface} from '../../../app/shared/components';
import {
    AmountControl,
    AutocompleteControl,
    BaseControl,
    DatepickerControl,
    SelectControl
} from '../../../app/shared/classes';
import {ExecutionsSymbolsValidator} from 'appEntries/panel/validators';

export const PanelReportsExecutionsStorageId = 'PanelReportsExecutionsComponent';

export const PanelReportsExecutionsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: ReportExecutionColumnNames.ReportTime,
            placeholder: 'Report time',
            controls: [
                new SelectControl({
                    name: ReportExecutionColumnNames.ReportTime,
                    value: 'false',
                    placeholder: 'Report time',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'Exchange time',
                            value: 'false'
                        },
                        {
                            label: 'UTC time',
                            value: 'true'
                        }
                    ],
                })
            ],
            shown: true,
            sortIndex: 1
        },
        {
            name: ReportExecutionColumnNames.Symbol,
            placeholder: 'Symbol',
            controls: [
                new BaseControl({
                    name: ReportExecutionColumnNames.Symbol,
                    value: null,
                    placeholder: 'Symbol',
                    validators: [ExecutionsSymbolsValidator()],
                    componentType: ComponentTypesEnum.Text,
                })
            ],
            shown: true,
            sortIndex: 2
        },
        {
            name: ReportExecutionColumnNames.Type,
            placeholder: 'Type',
            controls: [
                new SelectControl({
                    name: ReportExecutionColumnNames.TypeId,
                    value: UnspecifiedKeysEnum.UnspecifiedExecutionTypeKey,
                    placeholder: 'Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedExecutionTypeKey
                        },
                        {
                            label: 'Buy',
                            value: ExecutionsReportTypeEnum.Buy
                        },
                        {
                            label: 'Sell',
                            value: ExecutionsReportTypeEnum.Sell
                        },
                        {
                            label: 'Sell Short',
                            value: ExecutionsReportTypeEnum.SellShort
                        }
                    ],
                })
            ],
            shown: true,
            sortIndex: 3
        },
        {
            name: ReportExecutionColumnNames.Price,
            placeholder: 'Price',
            controls: [
                new AmountControl({
                    name: ReportExecutionColumnNames.PriceFrom,
                    value: null,
                    placeholder: 'Price From',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 1
                }),
                new AmountControl({
                    name: ReportExecutionColumnNames.PriceTo,
                    value: null,
                    placeholder: 'Price To',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 2
                }),
            ],
            shown: true,
            sortIndex: 4
        },
        {
            name: ReportExecutionColumnNames.QTY,
            placeholder: 'Quantity',
            controls: [
                new BaseControl({
                    name: ReportExecutionColumnNames.QuantityFrom,
                    value: null,
                    placeholder: 'Quantity From',
                    validators: [OnlyDigitsValidator()],
                    componentType: ComponentTypesEnum.Text,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: ReportExecutionColumnNames.QuantityТо,
                    value: null,
                    placeholder: 'Quantity То',
                    validators: [OnlyDigitsValidator()],
                    componentType: ComponentTypesEnum.Text,
                    sortIndex: 2
                }),
            ],
            shown: true,
            sortIndex: 5
        },
        {
            name: ReportExecutionColumnNames.Route,
            placeholder: 'Route',
            controls: [
                new BaseControl({
                    name: ReportExecutionColumnNames.Route,
                    value: null,
                    placeholder: 'Route',
                    validators: [LatinDigitsValidator(false)],
                    componentType: ComponentTypesEnum.Text,
                })
            ],
            shown: true,
            sortIndex: 6
        },
        {
            name: ReportExecutionColumnNames.Liquidity,
            placeholder: 'Liquidity',
            controls: [
                new BaseControl({
                    name: ReportExecutionColumnNames.Liquidity,
                    value: null,
                    placeholder: 'Liquidity',
                    validators: [LatinDigitsValidator(false)],
                    componentType: ComponentTypesEnum.Text,
                })
            ],
            shown: true,
            sortIndex: 7
        },
        {
            name: ReportExecutionColumnNames.OrderId,
            placeholder: 'Order ID',
            controls: [
                new BaseControl({
                    name: ReportExecutionColumnNames.OrderId,
                    value: null,
                    placeholder: 'Order ID',
                    validators: [],
                    componentType: ComponentTypesEnum.Text,
                })
            ],
            shown: true,
            sortIndex: 8
        },
        {
            name: ReportExecutionColumnNames.Group,
            placeholder: 'Group',
            controls: [
                new AutocompleteControl({
                    name: ReportExecutionColumnNames.Group,
                    value: UnspecifiedKeysEnum.UnspecifiedAccountsKey,
                    placeholder: 'Group',
                    validators:  [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedAccountsKey
                        }
                    ]
                })
            ],
            shown: true,
            sortIndex: 9
        },
        {
            name: ReportExecutionColumnNames.AccountReferenceId,
            placeholder: 'Account',
            controls: [
                new AutocompleteControl({
                    name: ReportExecutionColumnNames.AccountReferenceId,
                    value: null,
                    placeholder: 'Account',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [],
                    grouped: false
                })
            ],
            shown: true,
            sortIndex: 10
        },
        {
            name: ReportExecutionColumnNames.Date,
            placeholder: 'Date',
            controls: [
                new DatepickerControl({
                    name: ReportExecutionColumnNames.FromDate,
                    value: null,
                    placeholder: 'Date From',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker
                }),
                new DatepickerControl({
                    name: ReportExecutionColumnNames.ToDate,
                    value: null,
                    placeholder: 'Date to',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker
                })
            ],
            shown: true,
            sortIndex: 11
        }
    ];
};

export const PanelReportsExecutionsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({ label: 'Date', selector: ReportExecutionColumnNames.Date}),
        new ReportTableColumn({ label: 'Account', selector: ReportExecutionColumnNames.Account}),
        new ReportTableColumn({ label: 'Type', selector: ReportExecutionColumnNames.Type}),
        new ReportTableColumn({ label: 'QTY', selector: ReportExecutionColumnNames.QTY, shifted: true}),
        new ReportTableColumn({ label: 'Symbol', selector: ReportExecutionColumnNames.Symbol}),
        new ReportTableColumn({ label: 'Price', selector: ReportExecutionColumnNames.Price, shifted: true}),
        new ReportTableColumn({ label: 'Route', selector: ReportExecutionColumnNames.Route }),
        new ReportTableColumn({ label: 'EXEC BKR', selector: ReportExecutionColumnNames.ExecBkr }),
        new ReportTableColumn({ label: 'CONTRA', selector: ReportExecutionColumnNames.Contra}),
        new ReportTableColumn({ label: 'LIQ', selector: ReportExecutionColumnNames.Liquidity}),
        new ReportTableColumn({ label: 'COMM', selector: ReportExecutionColumnNames.Commission, shifted: true}),
        new ReportTableColumn({ label: 'ECN', selector: ReportExecutionColumnNames.Ecn, shifted: true}),
        new ReportTableColumn({ label: 'Sec', selector: ReportExecutionColumnNames.Sec, shifted: true }),
        new ReportTableColumn({ label: 'ORF', selector: ReportExecutionColumnNames.Orf, shifted: true }),
        new ReportTableColumn({ label: 'Taf', selector: ReportExecutionColumnNames.Taf, shifted: true}),
        new ReportTableColumn({ label: 'EFTT', selector: ReportExecutionColumnNames.Eftt, shifted: true }),
        new ReportTableColumn({ label: 'CAT', selector: ReportExecutionColumnNames.Cat, shifted: true }),
        new ReportTableColumn({ label: 'NSCC', selector: ReportExecutionColumnNames.Nscc, shifted: true }),
        new ReportTableColumn({ label: 'ACC', selector: ReportExecutionColumnNames.Acc, shifted: true }),
        new ReportTableColumn({ label: 'CLR', selector: ReportExecutionColumnNames.Clr, shifted: true }),
        new ReportTableColumn({ label: 'PTFPF', selector: ReportExecutionColumnNames.Ptfpf, shifted: true }),
        new ReportTableColumn({ label: 'ORDER ID', selector: ReportExecutionColumnNames.OrderId, shifted: true}),
        new ReportTableColumn({ label: 'FILL ID', selector: ReportExecutionColumnNames.FillId, shifted: true }),
        new ReportTableColumn({ label: 'STATUS', selector: ReportExecutionColumnNames.Status, shifted: true }),
        new ReportTableColumn({ label: 'CURRENCY', selector: ReportExecutionColumnNames.Currency, shifted: true }),
        new ReportTableColumn({ label: 'MULTIPLIER', selector: ReportExecutionColumnNames.Multiplier, shifted: true }),
        new ReportTableColumn({ label: 'ISIN  CUSIP', selector: ReportExecutionColumnNames.IsinCusip, shifted: true }),
        new ReportTableColumn({ label: 'AQX TRADE REF', selector: ReportExecutionColumnNames.AqxTradeRef, shifted: true }),
    ],
    hiddenColumnIds: [],
    actionMenu: false,
    disableColumnsOptions: true
};
